import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <div className="text-gray-600">認証情報を確認中...</div>
          <div className="text-sm text-gray-400 mt-2">しばらくお待ちください</div>
          
          {/* Timeout fallback */}
          <div className="mt-4">
            <button
              onClick={() => window.location.href = '/login'}
              className="text-blue-600 hover:text-blue-800 text-sm underline"
            >
              時間がかかる場合はこちらをクリック
            </button>
          </div>
        </div>
      </div>
    )
  }

  // ローディングが完了し、ユーザーが存在しない場合はログインページへ
  if (!user) {
    return <Navigate to="/login" />
  }

  // ユーザーが存在する場合は子コンポーネントを表示
  return children
}